<template>
  <v-dialog :value="value" width="250px" persistent>
    <v-card>
      <v-card-title>Discount Margin</v-card-title>
      <v-card-text class="black--text">
        <v-text-field
          :value="discountMargin"
          type="number"
          outlined
          hide-details
          dense
          @input="updateDiscountMargin"
          @keydown="onKeyDown"
        />
      </v-card-text>
      <v-card-actions>
        <g-button label="Cancel" @onclick="close" />
        <div class="flex-grow-1"></div>
        <g-button label="Save" @onclick="save" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    data: Object,
  },
  data() {
    return {
      discountMargin: "",
    };
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.discountMargin = this.data?.discountMargin || "";
      }
    },
  },
  methods: {
    onKeyDown(e) {
      if (e.key === "." || e.key === "-" || e.key === "+") return;
    },
    updateDiscountMargin(value) {
      this.discountMargin = value;
    },
    close() {
      this.$emit("input", false);
    },
    save() {
      this.$emit("update", this.discountMargin);
      this.close();
    },
  },
};
</script>
